module.exports = __webpack_public_path__ + "3gard-50ff3c31.webp";